const BASE_URL = "/mandates";

export const PAGE_URLS = {
  home: "/",
  list: BASE_URL,
} as const;
